<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <!-- 설비분류 -->
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            codeGroupCd="SAI_EQUIP_CLASS_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="saiEquipClassCd"
            label="설비분류"
            v-model="searchParam.saiEquipClassCd"
          ></c-select>
        </div>
        <!-- 사용여부 -->
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="점검항목 목록"
      :columns="grid.columns"
      :data="grid.data"
      :editable="editable"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline >
          <c-btn 
            v-if="editable" 
            label="추가" 
            :showLoading="false" 
            icon="add" 
            @btnClicked="add" />
          <c-btn
            v-if="editable && grid.data.length > 0"
            :url="saveUrl"
            :isSubmit="isSave"
            :param="grid.data"
            mappingType="POST"
            label="저장"
            icon="save"
            @beforeAction="saveItem"
            @btnCallback="saveCallback" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
  </div>
</template>

<script>
import { uid } from "quasar";
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'patrol-item',
  data() {
    return {
      searchParam: {
        plantCd: '',
        saiEquipClassCd: null,
        useFlag: 'Y',
      },
      grid: {
        columns: [],
        data: [],
      },
      editable: true,
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      isSave: false,
      listUrl: '',
      saveUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.patrol.resultItem.list.url;
      this.saveUrl = transactionConfig.sai.patrol.resultItem.insert.url;
      // code setting
      this.$comm.getComboItems('SAI_EQUIP_CLASS_CD').then(_result => {
        this.$comm.getComboItems('SAI_ITEM_CLASS_CD').then(__result => {
          this.grid.columns = [
            {
              name: 'plantCd',
              field: 'plantCd',
              label: '사업장',
              align: 'center',
              sortable: true,
              required: true,
              style: 'width:100px',
              type: 'plant',
            },
            {
              name: 'saiEquipClassCd',
              field: 'saiEquipClassCd',
              label: '설비분류',
              align: 'center',
              sortable: true,
              style: 'width:150px',
              type: 'select',
              comboItems: _result,
              required: true,
            },
            {
              name: 'saiItemClassCd',
              field: 'saiItemClassCd',
              label: '항목분류',
              align: 'center',
              sortable: true,
              style: 'width:100px',
              type: 'select',
              comboItems: __result,
              required: true,
            },
            {
              name: 'patrolItemName',
              field: 'patrolItemName',
              label: '점검항목',
              align: 'left',
              sortable: true,
              style: 'width:350px',
              type: 'text',
              required: true,
            },
            {
              name: 'useFlag',
              field: 'useFlag',
              label: '사용여부',
              align: 'center',
              sortable: true,
              style: 'width:100px',
              type: 'check',
              true: 'Y',
              false: 'N',
            },
            {
              name: 'sortOrder',
              field: 'sortOrder',
              label: '정렬순서',
              align: 'center',
              sortable: true,
              style: 'width:100px',
              type: 'number',
            },
          ]
        });
      });
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data.resultItems;
      },);
    },
    add() {
      this.grid.data.splice(0, 0, {
        saiPatrolResultItemId: uid(),  // 순회점검 일련번호`
        plantCd: null,  // 사업장 코드
        saiEquipClassCd: null,  // 설비 분류 코드(공통 포함) ** 순회에서만 사용
        saiItemClassCd: null,  // 항목 분류 코드
        patrolItemName: '',  // 점검항목
        useFlag: 'Y',  // 사용여부
        sortOrder: 0,  // 정렬순서
        regUserId: this.$store.getters.user.userId,
        editFlag: 'C',
      })
    },
    saveItem() {
      if (this.$comm.validTable(this.grid.columns, this.grid.data)) {
        window.getApp.$emit('CONFIRM', {
          title: '확인',
          message: '저장하시겠습니까?',
          // TODO : 필요시 추가하세요.
          type: 'info', // success / info / warning / error
          // 확인 callback 함수
          confirmCallback: () => {
            this.isSave = !this.isSave;
          },
          // 취소 callback 함수
          cancelCallback: () => {
          },
        });
      }
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList();
    },
  }
};
</script>
